import React from 'react';
import './MobileLayoutDefault.less';

function MobileLayoutDefault({ children }) {
  return (
    <div className="mobile-layout-default">      
      <div className="app-body-container">
        <div className="app-body-wrapper">
            {children}
        </div>
      </div>      
    </div>
  );
}

export default MobileLayoutDefault;
